/**
 * @file TrackMarketing.jsx
 * @description Handles marketing click tracking functionality for the BidCoin platform
 *
 * URL Format Examples:
 * Base URL: https://bidcoin.live/auction-details/0x47Da53B1c4dA082eB8953E6e4866c27afe0b7029
 * With Click Tracking: https://bidcoin.live/auction-details/0x47Da53B1c4dA082eB8953E6e4866c27afe0b7029?clickId=123
 */

import instance from "./AxiosConfig";
import Cookies from "js-cookie";

/**
 * Tracks marketing clicks by processing URL parameters and making an API call
 *
 * @async
 * @function trackClickId
 * @description
 * 1. Extracts clickId from URL query parameters
 * 2. Makes API call to track the click if clickId exists
 * 3. Cleans up URL by removing query parameters
 *
 * @example
 * // Usage in component
 * useEffect(() => {
 *   trackClickId();
 * }, []);
 *
 * @returns {Promise<void>}
 */
export const trackClickId = async () => {
    try {
        // Get clickId from URL parameters
        const urlParams = new URLSearchParams(window.location.search);
        const clickId = urlParams.get("clickId");

        // If no clickId is present, return early
        if (!clickId) {
            return;
        }
        Cookies.set("marketing_clickid", clickId);
        localStorage.setItem("marketing_clickid", clickId);
        console.log("marketing_clickid", Cookies.get("marketing_clickid"));
        console.log("marketing_clickidLocalStorage", localStorage.getItem("marketing_clickid"));

        // Call the tracking API with explicit headers
        const response = await instance.get(`/api/tracking/track-click`, {
            params: { clickid: Cookies.get("marketing_clickid") },
            withCredentials: true,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });

        // Clean up URL without refreshing the page
        const newUrl = window.location.pathname + window.location.hash;
        console.log("newUrl", newUrl);
        console.log("window.location.pathname", window.location.pathname);
        console.log("window.location.hash", window.location.hash);

        window.history.replaceState({}, document.title, newUrl);

        // Return the response data
        return response.data;
    } catch (error) {
        console.error("Error tracking click ID:", error);
        // Don't throw the error - we want this to fail silently
    }
};
